import { render, staticRenderFns } from "./SelectMedical.vue?vue&type=template&id=006d4df8&scoped=true"
import script from "./SelectMedical.vue?vue&type=script&lang=js"
export * from "./SelectMedical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006d4df8",
  null
  
)

export default component.exports